var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notifications") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-/-Morgan-Patrick",
    transform: "translate(-1156.000000, -28.000000)",
    fill: "#03053D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notifications",
    transform: "translate(1156.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,15.000044 L20,15.000044 L20,17.000044 L0,17.000044 L0,15.000044 L2,15.000044 L2,8 C2,5.878264 2.84285,3.843434 4.34315,2.343144 C5.84344,0.842854 7.87827,-6.66133815e-16 10,-6.66133815e-16 C12.1217,-6.66133815e-16 14.1566,0.842854 15.6569,2.343144 C17.1571,3.843434 18,5.878264 18,8 L18,15.000044 Z M16,15.000044 L16,8.000004 C16,6.408704 15.3679,4.882574 14.2426,3.757364 C13.1174,2.632144 11.5913,2.000004 10,2.000004 C8.4087,2.000004 6.88258,2.632144 5.75736,3.757364 C4.63214,4.882574 4,6.408704 4,8.000004 L4,15.000044 L16,15.000044 Z M7,19.000044 L13,19.000044 L13,21.000044 L7,21.000044 L7,19.000044 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.4ddc0b2efc1b412bacc2747feac8af18.svg";
export { ForwardRef as ReactComponent };